import styled from '@emotion/styled'

export const RemServTriangleDiv = styled.div`
  label: RemServTriangleDiv;
  clip-path: polygon(0 0, 50% 100%, 100% 0);
  margin-left: -30%;
  margin-right: -30%;
  position: absolute;
  z-index: -1;
  top: 0;
  border: ${(props) => '1px solid' + props.theme.colors.primary};
  width: 160%;
  height: 420px;
  background: ${(props) => props.theme.colors.primary};
  background-size: auto, auto, auto;
`

export const MaxxiaTriangleDiv = styled.div`
  label: MaxxiaTriangle;
  background-size: auto, auto, auto;
  clip-path: polygon(0 0, 50% 100%, 100% 0);
  background: url('images/maxxia-xx.png') center center no-repeat,
    url('images/maxxia-logo-white.png') center 35px no-repeat, #d14200;
  margin-left: -30%;
  margin-right: -30%;
  position: absolute;
  z-index: -1;
  top: 0;
  border: 1px solid #d14200;
  width: 160%;
  height: 420px;
`
